import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMinSpend } from 'hooks/use-min-spend';

import styles from './SiteHeaderOverlay.scss';

const SiteHeaderOverlay = ({ isActive }) => {
  const { showMinSpend } = useMinSpend();
  return (
    <div
      className={classNames(styles[isActive ? 'overlayActive' : 'overlay'], {
        [styles.hasMinSpend]: showMinSpend,
      })}
    />
  );
};

SiteHeaderOverlay.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

export default SiteHeaderOverlay;
